import React, { useState, useEffect } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import { uploadImage } from "./../../apis/tutors";
import warning from "../../assets/icons/warning.png";
import QualificationModal from "../../components/modals/Qualification.Modal";

var regexpUrl = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;

function TeachingOrEducationCertificateCheckbox(props) {
  const {
    certificates,
    providedAddistionalCerts,
    iscompletedForm,
    submitStep2Info,
    oncloseFile,
    fileupload,
    certificateNumber,
    validationError,
  } = props;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <div>
      <QualificationModal
        certificates={certificates}
        index={certificateNumber}
        qualificationModal={show}
        onclose={() => handleClose()}
      ></QualificationModal>
      {certificates[certificateNumber]?.teachingAndEducation?.length ||
      certificates[certificateNumber]?.doctoralDegree?.length ? (
        <div
          style={{
            display: providedAddistionalCerts === "true" ? "" : "none",
          }}
        >
          <div className="filled-data-card" style={{ marginTop: "20px" }}>
            {certificates[certificateNumber]?.teachingAndEducation?.length
              ? certificates[certificateNumber]?.teachingAndEducation?.map(
                  (qualifi, index) => {
                    return (
                      <div key={index + ""}>
                        <label className="label">
                          TEACHING AND EDUCATION CERTIFICATES
                        </label>
                        <span className="flex-between-center">
                          {qualifi}
                          {certificates[certificateNumber]?.teachingAndEducation
                            ?.length ===
                            index + 1 &&
                          !certificates[certificateNumber]?.doctoralDegree
                            ?.length ? (
                            <span
                              className="edit-style"
                              onClick={
                                !iscompletedForm
                                  ? () => {
                                      submitStep2Info(false);
                                      handleShow();
                                      //props.history.push(
                                      //  "/tutor-application-form/qualificationForm"
                                      //);
                                    }
                                  : () => {}
                              }
                              style={{ cursor: "pointer" }}
                            >
                              Edit
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    );
                  }
                )
              : ""}
            {certificates[certificateNumber]?.doctoralDegree?.length
              ? certificates[certificateNumber].doctoralDegree.map(
                  (degree, index) => {
                    return (
                      <>
                        <label className="label">DOCTORAL DEGREE</label>
                        <span className="flex-between-center">
                          {degree}
                          {certificates[certificateNumber]?.doctoralDegree
                            ?.length ===
                          index + 1 ? (
                            <span
                              className="edit-style"
                              onClick={
                                !iscompletedForm
                                  ? () => {
                                      submitStep2Info();
                                      handleShow();
                                      //props.history.push(
                                      //  "/tutor-application-form/qualificationForm"
                                      //);
                                    }
                                  : () => {}
                              }
                            >
                              Edit
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </>
                    );
                  }
                )
              : ""}
          </div>
          <h3
            className="title"
            style={{
              color: !certificates[certificateNumber]?.files?.length
                ? validationError?.data
                  ? "#fa4a4a"
                  : ""
                : "",
            }}
          >
            Add supporting documents to verify your qualifications, supporting
            documents will appear as verified on your tutor profile.
          </h3>
          <p
            className="sub title"
            style={{
              color: !certificates[certificateNumber]?.files?.length
                ? validationError?.data
                  ? "#fa4a4a"
                  : ""
                : "",
            }}
          >
            <i
              className="mdi mdi-lock mr-1"
              style={{
                color: !certificates[certificateNumber]?.files?.length
                  ? validationError?.data
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            ></i>
            This information is used to verify and award you with a badge on
            your tutor profile and is not shared with other users of Askademia
          </p>
          <ul className="files-list">
            {certificates[certificateNumber]?.files?.length
              ? certificates[certificateNumber].files.map((file, index) => {
                  return (
                    <li key={index}>
                      <span> {file?.name}</span>
                      <i
                        style={{
                          textAlign: "right",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          oncloseFile(index, certificates[certificateNumber]);
                        }}
                        className="mdi mdi-close"
                      ></i>
                    </li>
                  );
                })
              : ""}
          </ul>
          <span
            className="green-link-1"
            style={{
              color: !certificates[certificateNumber]?.files?.length
                ? validationError?.data
                  ? "#fa4a4a"
                  : ""
                : "",
            }}
          >
            <i
              className="mdi mdi-plus"
              style={{
                color: !certificates[certificateNumber]?.files?.length
                  ? validationError?.data
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            ></i>
            Add File
            {!iscompletedForm ? (
              <input
                type="file"
                accept="application/pdf"
                onChange={(file) => {
                  console.log(certificates[certificateNumber]);
                  fileupload(file, certificates[certificateNumber]);
                }}
              />
            ) : (
              ""
            )}
          </span>
        </div>
      ) : (
        <div>
          <div
            className="btn-transparent-outline"
            style={{
              marginTop: "20px",
              display: providedAddistionalCerts === "true" ? "" : "none",
              color: validationError?.data
                ? certificateNumber === 0
                  ? !certificates[certificateNumber]?.teachingAndEducation
                      ?.length &&
                    !certificates[certificateNumber]?.doctoralDegree?.length
                    ? "#fa4a4a"
                    : ""
                  : ""
                : "",
              borderColor: validationError?.data
                ? certificateNumber === 0
                  ? !certificates[certificateNumber]?.teachingAndEducation
                      ?.length &&
                    !certificates[certificateNumber]?.doctoralDegree?.length
                    ? "#fa4a4a"
                    : ""
                  : ""
                : "",
              backgroundColor: validationError?.data
                ? certificateNumber === 0
                  ? !certificates[certificateNumber]?.teachingAndEducation
                      ?.length &&
                    !certificates[certificateNumber]?.doctoralDegree?.length
                    ? "#fff1f1"
                    : ""
                  : ""
                : "",
            }}
            onClick={() => {
              submitStep2Info();
              handleShow();
              //props.history.push(
              //  "/tutor-application-form/qualificationForm"
              //);
            }}
          >
            <div
              className="btn-circle"
              style={{
                backgroundColor: validationError?.data
                  ? certificateNumber === 0
                    ? !certificates[certificateNumber]?.teachingAndEducation
                        ?.length &&
                      !certificates[certificateNumber]?.doctoralDegree?.length
                      ? "#fa4a4a"
                      : ""
                    : ""
                  : "",
              }}
            >
              <i
                className="mdi mdi-plus plusSize"
                style={{
                  color: validationError?.data
                    ? certificateNumber === 0
                      ? !certificates[certificateNumber]?.teachingAndEducation
                          ?.length &&
                        !certificates[certificateNumber]?.doctoralDegree?.length
                        ? "#ffffff"
                        : ""
                      : ""
                    : "",
                }}
              ></i>
            </div>{" "}
            Add teaching or education certificate
          </div>
          <div
            className="error"
            style={{
              display: providedAddistionalCerts === "true" ? "" : "none",
            }}
          >
            {validationError?.data
              ? certificateNumber === 0
                ? !certificates[certificateNumber]?.teachingAndEducation
                    ?.length &&
                  !certificates[certificateNumber]?.doctoralDegree?.length
                  ? warningError
                  : ""
                : ""
              : ""}
            {validationError?.data
              ? certificateNumber === 0
                ? !certificates[certificateNumber]?.teachingAndEducation
                    ?.length &&
                  !certificates[certificateNumber]?.doctoralDegree?.length
                  ? "Add your earned certificate or qualification"
                  : ""
                : ""
              : ""}
          </div>
        </div>
      )}
    </div>
  );
}

function TeachingOrEducationCertificate(props) {
  const {
    certificates,
    providedAddistionalCerts,
    iscompletedForm,
    submitStep2Info,
    oncloseFile,
    fileupload,
    validationError,
  } = props;

  useEffect(() => {
    if (
      certificates.length === 0 ||
      certificates[certificates.length - 1].teachingAndEducation.length > 0 ||
      certificates[certificates.length - 1].doctoralDegree.length > 0
    ) {
      certificates.push({
        teachingAndEducation: [],
        doctoralDegree: [],
        files: [],
      });
    }
  });

  return (
    <div>
      {certificates.map((certificate, index) => {
        return (
          <TeachingOrEducationCertificateCheckbox
            key={index}
            certificates={certificates}
            providedAddistionalCerts={providedAddistionalCerts}
            iscompletedForm={iscompletedForm}
            submitStep2Info={submitStep2Info}
            oncloseFile={oncloseFile}
            fileupload={fileupload}
            certificateNumber={index}
            validationError={validationError}
          ></TeachingOrEducationCertificateCheckbox>
        );
      })}
    </div>
  );
}

export const Second = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };
  const [state, setState] = useState({
    certificates: [],
    files: [],
    link: "",
    socialUrls: [],
    showLinkInput: null,
    previouslyTutored: "",
    providedAddistionalCerts: "",
    lengthOfTeachingPractice: "",
    informedStudent: null,
    supportingDocs: [],
    validateUrl: "",
  });

  const submitStep2Info = (isCallApi) => {
    const {
      previouslyTutored,
      providedAddistionalCerts,
      lengthOfTeachingPractice,
      informedStudent,
      supportingDocs,
      socialUrls,
    } = state;
    const { TutorInfoObj } = props;

    let step2 = {
      previouslyTutored,
      providedAddistionalCerts,
      lengthOfTeachingPractice,
      // informedStudent: informedStudent,
      supportingDocs,
      socialUrls,
      certificates: TutorInfoObj?.step2?.certificates
        ? TutorInfoObj?.step2?.certificates
        : [
            {
              teachingAndEducation: [],
              doctoralDegree: [],
              files: [],
            },
          ],
    };
    TutorInfoObj.step2 = step2;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (
    //   previouslyTutored !== "" &&
    //   (lengthOfTeachingPractice === 0 || lengthOfTeachingPractice) &&
    //   supportingDocs.length &&
    //   TutorInfoObj?.step2?.certificates
    // ) {
    //   TutorInfoObj.step2 = step2;
    //   props.AddTutorInfo(TutorInfoObj);

    //   return true;
    // } else {
    //   return false;
    // }
  };

  const fileupload = (file, certificate) => {
    if (file.target.files[0] == null) {
      return;
    }
    let supportingDocs = state.supportingDocs ? state.supportingDocs : [];
    const image = file.target.files[0];
    let formdata = new FormData();
    formdata.append("image", image);
    certificate.files.push(file.target.files[0]);
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;
    uploadImage({ token, typeNo: "3", file: formdata })
      .then((res) => {
        if (res.data.message === "image uploaded successfully") {
          supportingDocs.push(res.data.uploadImagePath);
          setState({
            ...state,
            supportingDocs,
          });
        }
      })
      .catch((err) => console.log(err, "==err"));
    setState({
      ...state,
    });
  };

  const oncloseFile = (index, certificate) => {
    certificate.files.splice(index, 1);
    setState({
      ...state,
    });
  };

  const onDeleteLink = (index) => {
    state.socialUrls.splice(index, 1);
    setState({
      ...state,
    });
  };
  const addLink = () => {
    if (regexpUrl.test(state.link)) {
      state.socialUrls.push(state.link);
      setState({
        ...state,
        link: "",
        showLinkInput: false,
      });
    } else {
      setState({
        ...state,
        validateUrl: "Please enter a valid URL",
      });
    }
  };
  useEffect(() => {
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    let previouslyTutored = TutorInfoObj?.step2?.previouslyTutored;
    let providedAddistionalCerts =
      TutorInfoObj?.step2?.providedAddistionalCerts;
    let lengthOfTeachingPractice =
      TutorInfoObj?.step2?.lengthOfTeachingPractice;
    let informedStudent = TutorInfoObj?.step2?.informedStudent;
    let supportingDocs =
      TutorInfoObj && TutorInfoObj.step2 && TutorInfoObj.step2.supportingDocs
        ? TutorInfoObj.step2.supportingDocs
        : [];
    let socialUrls = TutorInfoObj?.step2?.socialUrls
      ? TutorInfoObj?.step2?.socialUrls
      : [];
    let certificates = TutorInfoObj?.step2?.certificates
      ? TutorInfoObj?.step2?.certificates
      : {
          teachingAndEducation: [],
          doctoralDegree: [],
        };
    setState((state) => ({
      ...state,
      //certificates: certificates,
      //previouslyTutored,
      //providedAddistionalCerts,
      informedStudent,
      supportingDocs,
      socialUrls,
      //lengthOfTeachingPractice,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 2) {
      submitStep2Info(true);
    }
  }, [props]);
  const {
    certificates,
    files,
    socialUrls,
    link,
    showLinkInput,
    previouslyTutored,
    providedAddistionalCerts,
    informedStudent,
    lengthOfTeachingPractice,
    supportingDocs,
    validateUrl,
  } = state;
  const { iscompletedForm, validationError } = props;

  //console.log(state.certificates);

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={2} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="subject-mode skill-div"
            >
              <h1 className="step-title">Skills and experiences</h1>
              <h2 className="title">
                Have you previously tutored these subjects informally or another
                platform?
              </h2>
              <div className="row">
                <div className="col-lg-12 green-radio-custom">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline1"
                      name="customRadioInline1"
                      className="custom-control-input"
                      defaultChecked={previouslyTutored === true ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline1"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                previouslyTutored: true,
                              })
                          : () => {}
                      }
                    >
                      Yes, I have
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline2"
                      name="customRadioInline1"
                      className="custom-control-input"
                      defaultChecked={
                        previouslyTutored === false ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline2"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                previouslyTutored: false,
                              })
                          : () => {}
                      }
                    >
                      No, I haven’t
                    </label>
                  </div>
                </div>
              </div>
              <h2 className="title">
                Do you have teaching certificates or qualification relevant to
                the subject’s you’ll be tutoring?
              </h2>
              <h3 className="sub title">
                This information will help parents’ students make informed
                decisions and will not affect your application.
              </h3>
              <div className="row">
                <div className="col-lg-12 green-radio-custom">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline3"
                      name="customRadioInline3"
                      className="custom-control-input"
                      defaultChecked={
                        providedAddistionalCerts === "true" ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline3"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                providedAddistionalCerts: "true",
                              })
                          : () => {}
                      }
                    >
                      Yes, I have
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline4"
                      name="customRadioInline3"
                      className="custom-control-input"
                      defaultChecked={
                        providedAddistionalCerts === "false" ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline4"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                providedAddistionalCerts: "false",
                              })
                          : () => {}
                      }
                    >
                      No, I haven’t
                    </label>
                  </div>
                </div>
              </div>

              <TeachingOrEducationCertificate
                certificates={certificates}
                providedAddistionalCerts={providedAddistionalCerts}
                iscompletedForm={iscompletedForm}
                submitStep2Info={submitStep2Info}
                oncloseFile={oncloseFile}
                fileupload={fileupload}
                validationError={validationError}
              ></TeachingOrEducationCertificate>

              <div
                style={{
                  borderBottom: "1px solid #00000033",
                  marginTop: "46.5px",
                }}
              />

              <h2 className="title">
                How long have you been practicing, teaching or tutoring the
                subjects that you’ll be tutoring?
              </h2>
              <div className="row">
                <div className="col-lg-12 green-radio-custom">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline7"
                      name="customRadioInline7"
                      className="custom-control-input"
                      defaultChecked={
                        lengthOfTeachingPractice === 0 ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline7"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                lengthOfTeachingPractice: 0,
                              })
                          : () => {}
                      }
                    >
                      Less than a year
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline8"
                      name="customRadioInline7"
                      className="custom-control-input"
                      defaultChecked={
                        lengthOfTeachingPractice === 1 ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline8"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                lengthOfTeachingPractice: 1,
                              })
                          : () => {}
                      }
                    >
                      Between 1 – 4 years
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline9"
                      name="customRadioInline7"
                      className="custom-control-input"
                      defaultChecked={
                        lengthOfTeachingPractice === 3 ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline9"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              setState({
                                ...state,
                                lengthOfTeachingPractice: 3,
                              })
                          : () => {}
                      }
                    >
                      More than 5 years
                    </label>
                  </div>
                </div>
              </div>
              <h2 className="title">
                Do you have a social media following or website related to
                tutoring or teaching your subjects?
              </h2>
              <h3 className="sub title">
                Add links to your Instagram, Twitter, Facebook, website, blog,
                or articles written by you or about you. Other users of
                Askademia will not see this information.
              </h3>
              <ul className="files-list">
                {socialUrls?.length
                  ? socialUrls.map((link, index) => {
                      return (
                        <li key={index}>
                          {link}
                          <i
                            className="mdi mdi-close"
                            onClick={
                              !iscompletedForm
                                ? () => onDeleteLink(index)
                                : () => {}
                            }
                          ></i>
                        </li>
                      );
                    })
                  : ""}
              </ul>
              <span
                onClick={
                  !iscompletedForm
                    ? () =>
                        setState({ ...state, showLinkInput: !showLinkInput })
                    : () => {}
                }
                className="green-link-1"
              >
                <i className="mdi mdi-plus"></i>Add Link
              </span>
              {showLinkInput ? (
                <div>
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control flex-center-center"
                      placeholder="Your Url"
                      style={{
                        borderColor: validateUrl ? "#fa4a4a" : "",
                        backgroundColor: validateUrl ? "#fff1f1" : "",
                      }}
                      onChange={(e) =>
                        setState({
                          ...state,
                          link: e.target.value,
                        })
                      }
                      onFocus={(e) =>
                        setState({
                          ...state,
                          validateUrl: "",
                        })
                      }
                      value={link}
                    />
                    <Button
                      onClick={addLink}
                      style={{
                        borderRadius: " 0px 5px 5px 0px",
                        height: "56px",
                      }}
                    >
                      Add
                    </Button>
                  </div>
                  <div className="error" style={{ marginTop: "5px" }}>
                    {validateUrl ? warningError : ""}
                    {validateUrl ? validateUrl : ""}
                  </div>
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Nextsteps step={2} {...props} submitStepInRedux={submitStep2Info} />
        </div>
      </Col>
    </Row>
  );
};
